@if (this.to.label) {
  <div class="fs-6 mt-2 mb-2">
    {{ this.to.label | translate }}
  </div>
}
<mat-card appearance="outlined" class="grid-container mb-3">
  <ag-grid-angular class="ag-theme-material grid" [gridOptions]="gridOptions"></ag-grid-angular>
  @if (!isReadOnly) {
    <button
      (click)="onAddClicked()"
      matTooltipPosition="before"
      [matTooltip]="'DEMAND_REQUEST.DETAIL.PRODUCTS.GRID.ADD.TOOLTIP' | translate"
      mat-fab
      color="primary"
      class="fab-t-r"
    >
      <mat-icon>add</mat-icon>
    </button>
  }
</mat-card>
